import { useQuery } from 'react-query';

import Api from 'core/api';
import { staleTime } from 'constants/api';

const useFeatureOnboardingList = ({ enabled = true } = {}) =>
  useQuery({
    enabled,
    queryKey: ['common.getFeatureOnboardingList'],
    queryFn: () => Api.common.getFeatureOnboardingList(),
    staleTime,
  });

export default useFeatureOnboardingList;
